import { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../utils/ContextProvider";
import Loader from "../../components/Loader";
import { useNavigate } from 'react-router-dom';
import './style.css'
import API from '../../utils/API';
import Swal from 'sweetalert2';
import SegmentedControl from '../../components/SegmentedControl';
import UtilityBillAccount from '../../components/UtilityBillAccount';
import UtilityBillLine from '../../components/UtilityBillLine';

const UtilityBills = (props) => {

    const [utilities, setUtilities] = useState()
    const [filteredUtilities, setFilteredUtilities] = useState()
    const [selectedAccount, setSelectedAccount] = useState(null)
    const [tags, setTags] = useState([])
    const [bills, setBills] = useState([])
    const [loading, setLoading] = useState(false)
    const [coOptions, setCoOptions] = useState([])
    const [tab, setTab] = useState(0)
    const [gasUnit, setGasUnit] = useState('m3')
    const [waterUnit, setWaterUnit] = useState('l')
    const context = useContext(AppContext)
    const navigate = useNavigate();

    useEffect(() => {
        if (!context.getUserInfo) return
        let access = ["access_utilities_list", "create_utilities", "update_utilities"]
        if (!access.some(item => context.getUserInfo[item] === true)) {
            navigate('/settings/roles')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.getUserInfo])

    useEffect(() => {
        if (!props.building) return

        const cancelToken = API.cancelToken();
        setLoading(true)

        API.getUtilityBills(cancelToken, props.building).then(res => {
            setUtilities(res.data)
            setTags([...new Set(res.data.flatMap(e => e.tags || []))]);
            return
        }).catch(err => {
            console.log(err)
            if (err.message === 'cancelling') return
            let message = 'Please try again later.'
            if (err.response && err.response.data && err.response.data.includes('error')) {
                message = err.response.data.error
            }
            Swal.fire({
                title: 'Error.',
                text: message,
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e',
            });

        }).finally(f => {
            setLoading(false)
        })

        API.getModelsCo(cancelToken).then(res => {
            const dict = res.data.reduce((acc, item) => {
                acc[item.model_id] = item.model_name;
                return acc;
            }, {});
            setCoOptions(dict)
        }).catch(err => {
            console.log(err)
            if (err.message === 'cancelling') return
            if (err.response && err.response.data) {
                try {
                    if (err.response.data.includes('error')) {
                        Swal.fire({
                            title: 'Error.',
                            text: err.response.data.error,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    }
                } catch (e) {
                    Swal.fire({
                        title: 'Error.',
                        text: err.response.data,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                }
            } else {
                Swal.fire({
                    title: 'Error.',
                    text: 'An error occurred, please try again later.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
            }
        })
        return () => {
            API.cancel(cancelToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.building])

    useEffect(() => {
        if (!utilities) return
        let newList = utilities.filter(e => e.type === tab || e.id === null)
        newList.push({ id: null, building_id: props.building, name: "", account_id: "", type: tab, tags: [] })
        setFilteredUtilities(newList)
    }, [utilities, tab, props.building])

    useEffect(() => {
        if (!filteredUtilities) return
        let tempAccount = filteredUtilities.filter(e => e.id === selectedAccount)
        setBills(tempAccount[0] ? tempAccount[0].bills : [])
    }, [selectedAccount, filteredUtilities])


    return (
        <div className='tablet:py-8 mobile:py-3 min-h-[80vh]'>
            <SegmentedControl onChange={setTab} segments={['Electrical', 'Natural Gas', 'Water']} defaultSelected={tab} />
            <div className=''>

                {
                    loading &&
                    <Loader />
                }
                <div className='tablet:p-8 mobile:p-3 min-h-[80vh]'>
                    <p className='text-2xl my-6'>Accounts</p>
                    <div className="flex flex-wrap items-center justify-start gap-8 py-6 w-full">
                        {
                            filteredUtilities && filteredUtilities.map((u, i) => (
                                <UtilityBillAccount
                                    key={i + "utilitiyaccount"}
                                    item={u}
                                    tags={tags}
                                    select={setSelectedAccount}
                                    selected={selectedAccount && selectedAccount === u.id}
                                    setUtilities={setUtilities}
                                    coModels={coOptions}
                                />
                            ))
                        }
                    </div>

                    {
                        <div className='mt-6'>
                            <p className='text-2xl my-6'>Uploaded Bills</p>
                            <div className='mt-6 max-h-[400px] overflow-auto'>
                                {
                                    bills && bills.map((e, index) => (
                                        <UtilityBillLine
                                            key={index + "utilitybill"}
                                            gasUnit={gasUnit}
                                            setGasUnit={(e) => setGasUnit(e.target.value)}
                                            waterUnit={waterUnit}
                                            setWaterUnit={(e) => setWaterUnit(e.target.value)}
                                            value={e}
                                            setUtilities={setUtilities}
                                            type={tab}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default UtilityBills;